module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_phone.19603.png";